(function (angular) {
	'use strict';

	angular.module('PinMeTo.directives').component('pmtCountryRegionDropdown', {
		templateUrl: 'pmtShared/directives/pmtCountryRegionDropdown.html',
		controller: Dropdown,
		bindings: {
			countryCode: '<',
			selectedValue: '<',
			onSelectedValueChanged: '<',
			emptyDefault: '<'
		}
	});

	Dropdown.$inject = ['countryData'];
	function Dropdown(countryData) {
		let $ctrl = this;
		$ctrl.selectedCountryRegion = { selected: $ctrl.selectedValue };
		$ctrl.countryRegions = new Map();
		$ctrl.regionsForCountry = [];

		this.compareCountryRegions = function (a, b) {
			return a != null && b != null && a.name === b.name;
		};

		this.showCountryRegionInDropDown = function (x) {
			return x != null ? x.name : 'selected item is undefined!';
		};

		this.$onChanges = function () {
			let update = angular.copy($ctrl.selectedCountryRegion);
			update.selected = $ctrl.selectedValue;
			$ctrl.selectedCountryRegion = update;
			$ctrl.regionsForCountry = $ctrl.countryRegions.get($ctrl.countryCode) || [];
		};

		countryData.getCountryData().then(
			function (data) {
				$ctrl.countryRegions = data.countryRegions;
				$ctrl.$onChanges();
			},
			function (err) {
				console.log('failed to get country regions', err);
			}
		);
	}
})(window.angular);
